/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LpInspectionCouponDto } from '../../models/lp-inspection-coupon-dto';

export interface LpInspectionCouponControllerDelete$Params {
  id: string;
}

export function lpInspectionCouponControllerDelete(http: HttpClient, rootUrl: string, params: LpInspectionCouponControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponDto>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionCouponControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LpInspectionCouponDto>;
    })
  );
}

lpInspectionCouponControllerDelete.PATH = '/api/lp-inspection-coupon/{id}';
